import { admin, forecaster, guest } from "./axios";
import { setUser, clearUser } from "../slices/userSlice";
import { AppDispatch } from "../store";
import {
  clearClientSsoAuthFlag,
  isClientSsoAuthSession,
  setClientSsoAuthFlag,
} from "../../constants/clientSso";

export const inviteUser = async (
  fullName: string,
  email: string,
  groupName: string
) => {
  try {
    const response = await admin.post(`admin/users/invite`, {
      fullName,
      email,
      groupName,
    });
    return response;
  } catch (error: unknown) {
    console.error("Error inviting user", error);
    throw error;
  }
};

export const acceptInvite = async (
  email: string,
  tempPassword: string,
  newPassword: string
) => {
  const response = await admin.post(`auth/verify-temp-password`, {
    email,
    tempPassword,
    newPassword,
  });
  return response;
};

export const forgotPassword = async (email: string) => {
  const response = await admin.post(`auth/forgot-password`, {
    email,
  });
  return response;
};

export const resetPassword = async (
  email: string,
  confirmCode: string,
  newPassword: string
) => {
  const response = await admin.post(`auth/confirm-forgot-password`, {
    email,
    confirmCode,
    newPassword,
  });
  return response;
};

export const UserDetail = async () => {
  const path = isClientSsoAuthSession() ? "client-sso/me" : "auth/me";
  const response = await forecaster.get(path);
  return response;
};

export const userLogin =
  (email: string, password: string) => async (dispatch: AppDispatch) => {
    const response = await guest.post(`auth/login`, {
      email,
      password,
    });
    const { user } = response.data.data;
    clearClientSsoAuthFlag();
    dispatch(setUser(user));
    return response;
  };

export const clientSsoLogin =
  (token: string) => async (dispatch: AppDispatch) => {
    const response = await guest.post(`client-sso/login`, { token });
    const { user } = response.data.data;
    setClientSsoAuthFlag();
    dispatch(setUser(user));
    return response;
  };

export const revalidateClientSso = async () => {
  const response = await admin.post(`client-sso/revalidate`);
  return response;
};

export const logout = () => async (dispatch: AppDispatch) => {
  const path = isClientSsoAuthSession() ? "client-sso/signout" : "auth/signout";
  await forecaster.get(path);
  clearClientSsoAuthFlag();
  dispatch(clearUser());
  return true;
};

export const disableUser = async (userId: string) => {
  const response = await admin.put(`admin/users/${userId}/disable`);
  return response;
};

export const enableUser = async (userId: string) => {
  const response = await admin.put(`admin/users/${userId}/enable`);
  return response;
};
